<template>
  <div class="privacy">
    <!-- header -->
    <nav-header />
    <!-- content -->
    <div class="privacy-container">
      <div class="container-inner">
        <h2>即刻PDF隐私政策</h2>
        <h3>提示条款</h3>
        <p>
          保护用户的个人信息安全，是我们应负的责任。我们将按照相关法律法规的要求，充分利用我们现有的技术和资源，建立完善的个人信息安全保护体系，竭力保护您的个人信息安全。鉴于此，即刻PDF阅读器相关服务的运营公司及关联服务提供者（下称“我们”）制定本《隐私政策》（下称“本政策 /本隐私政策”）并提醒您
        </p>
        <p>
          在使用我们提供的各项服务前，请您务必仔细阅读并透彻理解本政策，您应该重点阅读以粗体/粗体下划线标识的条款，在确认充分理解并同意后进行使用。如果您不同意本隐私政策的任何内容，您应立即停止使用我们提供的服务。当您使用我们提供的任何服务时，即表示您已经同意我们按照本隐私政策来收集、使用和保护您的个人信息。如对本政策内容有任何疑问、意见或建议，您可通过即刻PDF阅读器官网提供的联系方式与我们联系。
        </p>
        <p>
          本隐私政策将帮助您了解以下内容：
        </p>
        <p>一、我们如何收集和使用您的信息</p>
        <p> 二、Cookie及同类型技术</p>
        <p> 三、我们如何共享、转让、披露您的信息</p>
        <p>四、我们如何保障您的个人信息安全</p>
        <p>五、您如何管理您的信息</p>
        <p>六、未成年人个人信息相关</p>
        <p>七、您的信息如何进行存储</p>
        <p> 八、本隐私政策如何更新</p>
        <p>九、如何联系我们</p>
        <h3> 一、我们如何收集和使用您的信息</h3>
        <p>（一）为了保证产品功能的正常实现</p>
        <p>
          1.在您使用我们提供的服务过程中，为了保证服务的正常运行，我们需要收集以下信息：
        </p>
        <p>
          1.1设备信息：请您理解，为了依据您的具体情况向您提供适配的服务（如不同的页面内容、功能项目、功能权限、交互方式等），我们可能会收集您所使用的设备的相关信息（例如设备型号、操作系统、浏览器版本、设备识别标识、IP地址等软硬件相关信息）。
        </p>
        <p>
          1.2使用信息：为了记录服务使用情况，维护我们提供的服务的正常运行，当您使用我们提供的服务时，我们可能会收集您对我们提供的服务的详细使用/运行情况，包括浏览、点击、交易、访问日期和时间、操作日志信息、崩溃报告等信息。
        </p>
        <p>
          （请注意，单独的使用信息属于无法识别特定自然人身份的信息，该等信息并未与特定自然人进行关联时，并非属于个人信息的范畴。我们会将这类信息进行匿名化处理。在未取得您的授权的情况下，我们不会将该等信息用于识别特定的自然人身份。）
        </p>
        <p>
          2.为了向您提供您选择的服务，我们将会收集您主动上传的文件信息，或者主动提供的其他信息。
        </p>
        <p>
          您在使用我们提供的服务过程中向我们主动提供的任何个人信息，我们都将采取严格的信息安全措施以保证您的信息安全，我们也仅会为了本隐私政策约定之目的而进行合理的使用，我们的使用行为绝不涉及未经过您允许的个人信息泄露行为。
        </p>
        <p>
          （二）帮助您完成注册
        </p>
        <p>
          如果您需要注册成为即刻PDF阅读器的注册用户，我们可能需要收集您的手机号、邮箱地址等信息以完成账号注册，非注册所必须信息由您自行选择是否提供。
        </p>
        <p>
          （三）为了向您提供优质的售中、售后服务或解决与您可能产生的争议
        </p>
        <p>
          1.为了完成服务的购买、续费、升级，我们可能收集您的支付状态以及注册账号的使用情况。
        </p>
        <p>
          2.当您联系我们要求提供售中、售后服务，或者要求我们处理与您存在的争议、纠纷时，我们可能需要您提供必要的信息以核验您的身份。
        </p>
        <p>
          3.为了向您提供更优质的售中、售后服务，我们还有可能使用您与我们取得联系时主动提供的其他各项信息。
        </p>
        <p>
          （四）为维护服务的稳定性以及向你您提供网络信息安全保障
        </p>
        <p>
          为保证您使用我们提供的服务的安全性、稳定性，更好地预防和应对网络欺诈、网络病毒、网络数据的扒取、网络侵入等问题，保护广大用户的个人信息安全、人身财产安全免于侵害，我们可能使用您的个人信息、交易信息、设备信息、使用信息来帮助我们判断您的个人账号安全与否（是否存在账号共享、非官方账号等情况）以及账号的使用情况是否会影响即刻PDF阅读器服务的稳定性(集中、过量地数据上传等行为可能会影响即刻PDF阅读器的稳定性)。
        </p>
        <p>
          （五）其他
        </p>
        <p>
          1.除本政策已经约定，任何对于您的个人信息的收集均会事先获得您的同意。
        </p>
        <p>
          2.如果我们从任何第三方处获得了您的信息，我们会明确要求第三方取得您的授权，包括对于您的个人信息的收集以及对该等信息分享的授权。如第三方存在违法行为的，我们将严正要求第三方主动承担相应法律责任；同时，我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
        </p>
        <p>
          3.为了优化您的客户体验，向您提供更具有针对性的服务，向您推荐其他我们的关联服务。在您允许收集的信息范围内，我们可能在且仅在我们内容对您的信息进行使用。
        </p>
        <p>
          4.您充分理解并同意，在以下情况下，我们收集、使用您的个人信息无需您的授权同意：
        </p>
        <p>（1）维护国家安全、国防安全、社会安全所必需的。</p>
        <p>（2）维护公共安全、公共卫生或其他重大公共利益所必需的。</p>
        <p> （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法相关的。</p>
        <p>（4）为了维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的。</p>
        <p>（5）涉及信息为您自行向社会公众公开的个人信息的。</p>
        <p> （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p> （7）为履行与您签订的相关协议或其他书面文件所必需的。</p>
        <p> （8）用于维护我们所提供的服务的安全稳定运行所必需的，例如查找、处理服务的故障。</p>
        <p> （9）为合法地新闻报道所必需的。</p>
        <p>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行匿名化处理的。</p>
        <p> （11）法律法规规定的其他情形。</p>
        <p>
          5.请您同意并理解，如果我们对个人信息进行了匿名化处理，使得该等数据无法于具体个人进行联系且无法复原，则我们可能会对收集的信息进行研究和统计，目的是提高我们的服务质量，提升我们的技术水平，并最终为您提供更优质的服务，经过匿名化处理且不可复原的信息不被视为个人信息，我们对该等信息的使用不再另行征得您的同意。
        </p>
        <h3>二、Cookie及同类型技术</h3>
        <p>
          当您访问我方网站时，我们可能会通过“Cookie”或其他同类型技术将某些信息存入您的设备，“Cookie”是网页服务器放置在您的设备上的一个小的文本文件，“Cookie”不能用于运行程序，也不会将病毒传播到您的计算机上。使用“Cookie”的目的是为您提供网页浏览的便捷（包括但不限于让您登录到我们的服务、记录首选项和设置），但并不表示本公司可自动获悉有关您的任何个人信息，我们对于“Cookie”的使用主要是为了保证网站的正常运转，以及向您提供更优质的使用感受。
        </p>
        <h3>三、我们如何共享、转让、披露您的信息</h3>
        <p>
          （一）共享
        </p>
        <p>
          我们不会和即刻PDF阅读器运营公司以外的公司、组织和个人共享您的个人信息，但以下情况除外：
        </p>
        <p>
          1.在法定情形下的共享：我们可能会根据法律法规的规定，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
        </p>
        <p>
          2.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </p>
        <p>
          3.与关联公司进行共享：为便于我们向您提供更优质的服务，推荐您可能感兴趣的信息，确认个人账号状态，保护我们关联公司或其他用户又或者公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司及/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。
        </p>
        <p>
          4.与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行某些职能，我们仅会出于本隐私政策中明确、合法、正当的目的共享您的信息，且授权合作伙伴不得将该等信息用于其他任何目的。
        </p>
        <p>
          目前，我们的授权合作伙伴包括以下类型：
        </p>
        <p>
          （1）广告、分析服务类的授权合作伙伴。未得到您的授权的情况下，我们不会将您的个人身份信息与提供广告、分析服务的合作伙伴共享。这些合作伙伴可能会帮助我们处理一些用户数据，但我们不会向其提供您的个人身份信息。我们可能将一些经过匿名化处理的数据共享给合作伙伴，这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议。
        </p>
        <p>
          （2）供应商、服务提供商和其他合作伙伴。该等合作伙伴向我们提供数据存储等技术基础设施服务、收集分析我们的服务使用情况、并协助我们提供客户服务、提供支付便利或展开研究和调查，该等供应商、服务提供商和其他合作伙伴将仅在合法合规的前提下收集/获得您的个人信息。
        </p>
        <p>
          我们会对合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并要求其按照本隐私政策来处理可能获得的个人信息。
        </p>
        <p>
          （二）转让
        </p>
        <p>
          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </p>
        <p>
          1.在获取您明确同意的情况下转让。
        </p>
        <p>
          2.在我们发生合并、收购或破产清算等情形，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您请求授权。
        </p>
        <p>
          （三）披露
        </p>
        <p>
          我们仅会在以下情况下，披露您的个人信息：
        </p>
        <p>
          1.获得您明确同意或您主动要求我们进行披露的。
        </p>
        <p>
          2.如果我们确定您出现违反法律法规或严重违反我们相关协议的情况，或为了保护国家利益、社会公众利益，我们可能依据法律法规披露关于您的个人信息。
        </p>
        <p>
          （四）例外
        </p>
        <p>
          以下情形中，共享、转让、披露您的个人信息无需事先征得您的授权同意：
        </p>
        <p>1.维护国家安全、国防安全、社会安全所必须的。</p>
        <p> 2.维护公共安全、公共卫生等重大公共利益所必需的。</p>
        <p> 3.与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的。</p>
        <p> 4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的。</p>
        <p> 5.涉及信息为您自行向社会公众公开的个人信息的。</p>
        <p> 6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p>
          请您同意，若我们对个人信息进行匿名化处理，使得数据无法与特定个人进行联系且不能复原，则此类处理后数据的共享、转让、披露无需另行向您通知并征得您的同意。
        </p>
        <h3>四、我们如何保障您的个人信息安全</h3>
        <p>
          （一）我们依照现有的技术水平，设置了合理的个人信息安全保护措施，保护您的个人信息。我们使用有效的的保护机制防止个人信息遭到恶意攻击，我们也针对员工进行了保密意识的培训并设置了完善的保密规范。
        </p>
        <p>
          我们严格控制信息访问权限，确保能够接触到您的个人信息的人员的必要性，并采取严格的措施对工作人员的行为进行管理，保护您的个人信息安全。
        </p>
        <p>
          （二）我们设置了全面的信息安全体系，从制度、人员、技术等多方面确保您的个人信息安全。
        </p>
        <p>
          （三）对于您的个人信息，我们仅会为了即刻PDF阅读器相关服务提供的需要，进行留存，除非法律有强制的要求（《中华人民共和国电子商务法》要求产品和服务信息、交易信息保存时间自交易完成之日起不少于三年。）
        </p>
        <p>
          在您的个人信息超出需要保留的期限后，我们会根据法律的要求删除您的个人信息，或将其匿名化处理。
        </p>
        <p>
          （四）我们提醒您，互联网环境并非绝对的安全，请您谨慎地考虑，是否在使用我们的服务时提供相关信息。也请您注意保护您的个人账号安全。
        </p>
        <p>
          我们将尽力保障您发送给我们的信息、文件的安全性。如果由于我方故意或存在重大过失的行为导致您的个人信息泄露并致使您的合法权益受损的，我们将依法承担相应的法律责任。
        </p>
        <p>
          （五）如不幸发生危害个人信息安全的事件，我们将按照监管部门的要求，及时上报个人信息安全事件的处理情况。
        </p>
        <h3>五、您如何管理您的信息</h3>
        <p>
          您可以通过以下方式访问及管理您的信息：
        </p>
        <p>
          （一）删除您的信息
        </p>
        <p>
          在以下情形中，您可以向我们提出删除个人信息的请求：
        </p>
        <p>1.如果我们处理个人信息的行为违反法律法规。</p>
        <p> 2.如果我们收集、使用您的个人信息，却未征得您的明确同意。</p>
        <p> 3.如果我们处理个人信息的行为严重违反了与您的约定。</p>
        <p> 4.如果您不再使用我们的产品或服务。</p>
        <p> 5.如果我们永久不再为您提供产品或服务。</p>
        <p>
          如果我们依据以上情况对您的信息进行删除，我们还将同时尽可能通知从我们处获得您的个人信息的其他主体，并要求其及时删除（除非其他主体已经获得了您的授权）。
        </p>
        <p>
          （二）查询、更正您的个人信息
        </p>
        <p>
          您可以依据即刻PDF阅读器官网的反馈，针对您的账号信息进行查询、更正，如果您对于查询、更正信息的方式存在疑惑的，请通过即刻PDF阅读器官网提供的联系方式，与我们进行联系。
        </p>
        <p>
          （三）系统自行决策行为处理
        </p>
        <p>
          在部分业务的处理中，系统可能仅依据其已有的设置自动做出决策。如果这些决策内容明显地损害了您的合法权益，您有权要求我们做出解释，我将在合理范围内针对您的要求做出解释和处理。
        </p>
        <p>
          （四）处理您的上述请求
        </p>
        <p>
          在您提出上述请求时，我们可能要求您提供书面请求，或以其他方式证明您的身份。我们可能会首先要求您证明自己的身份，以明确我们针对您的请求进行的处理的合理性。
        </p>
        <p>
          一般情况下，我们将在15个工作日内针对您的请求做出答复。如您不满意，还可以通过我们客户服务发起投诉。
        </p>
        <p>
          对于您合理的请求，我们会予以尽快处理。如果您的请求不切实际或者与您的个人身份信息缺乏关联性，又或者您的请求给他人合法权益带来风险，我们可能会予以拒绝。
        </p>
        <p>
          在以下情形中，按照法律法规的要求，我们将无法处理您的请求：
        </p>
        <p>1.与国家安全、国防安全、社会安全有关导致我方不予处理的。</p>
        <p>2.与公共安全、公共卫生等重大公共利益有关导致我方不予处理的。</p>
        <p>3.与犯罪侦查、起诉、审判和执行判决等有关导致我方不予处理的。</p>
        <p>4.有充分证据表明您的请求存在主观恶意或滥用权利的情况的。</p>
        <p>5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</p>
        <p> 6.涉及商业秘密导致我方不予处理的。</p>
        <h3>六、未成年人个人信息相关</h3>
        <p>
          由于互联网在线环境所致，我们无法针对用户的真实身份进行一一核验，我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。
        </p>
        <p>
          如您是未成年人的父母或其他监护人，请您关注您监护的未成年人在使用我们的服务前，您是否仔细阅读了本隐私政策并同意您监护的未成年人使用我方的服务。如您对您所监护的未成年人的个人信息相关内容有疑问，请通过我们提供的联系方式与我们联系。
        </p>
        <h3>七、您的信息如何进行存储</h3>
        <p>
          我们在中华人民共和国境内收集、产生的个人信息，存储在中国境内，但以下情形除外：
        </p>
        <p>
          1.相关法律法规有明确规定的。
        </p>
        <p>
          2.获得您明确授权的。
        </p>
        <p>
          针对以上情形，我们会确保依据本隐私政策对您的个人信息提供足够的保护。
        </p>
        <h3>八、本隐私政策如何更新</h3>
        <p>
          我们的隐私政策可能进行更新。
        </p>
        <p>
          对于本隐私政策的更新、修改，我们会进行展示或通知（我们会通过在具体网站进行公示的方式进行通知甚至向您提供弹窗提示，或者以其他有效方式进行通知）。
        </p>
        <h3>九、如何联系我们</h3>
        <p>
          如您对本政策内容有任何疑问或您发现您的个人信息可能被泄露。
        </p>
        <p>
          您均可以通过以下方式与我们联系，一般情况下，我们将在15个工作日内回复您的请求：
        </p>
        <p>
          客户服务邮箱：admin@zsincer.com
        </p>
        <p>
          如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，就本隐私内容与我方发生任何争议时，双方应尽量友好协商解决；协商不成时，则争议各方一致同意将发生的争议提交深圳市重诚远顺科技有限公司所在地有管辖权的人民法院提起诉讼。
        </p>
        <p class="tr">
          深圳市重诚远顺科技有限公司
        </p>
      </div>
    </div>
    <!-- footer -->
    <copy-right-footer />
  </div>
</template>

<script>
import CopyRightFooter from "../../components/CopyRightFooter";
import NavHeader from "../../components/NavHeader";
export default {
  components: {
    CopyRightFooter,
    NavHeader
  }
};
</script>

<style lang="scss" scoped>
.privacy {
  .privacy-header {
    width: 100%;
    min-width: 1200px;
    height: 65px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    .privacy-header-content {
      width: 1200px;
      height: 65px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin: 0 auto;
      .logo {
        width: 213px;
        height: 40px;
      }
    }
  }
  .privacy-container {
    width: 100%;
    min-width: 1200px;
    padding: 70px 50px 0 50px;
    box-sizing: border-box;
    background: #f6f6f6;
    .container-inner {
      width: 1200px;
      background-color: #fff;
      margin: 0 auto;
      padding: 60px 30px;
      box-sizing: border-box;
      color: #333;
    }
  }
  h2 {
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    margin-bottom: 40px;
  }
  h3 {
    font-size: 16px;
    margin-top: 20px;
    font-weight: 700;
  }
  p {
    text-indent: 24px;
    line-height: 25px;
    font-size: 16px;
    margin-top: 20px;
  }
  .tr {
    text-align: right;
  }
}
</style>
